import React from "react";
import { Button, Icon } from "..";

import {
  YearHeaderInput,
  MonthHeaderInput,
  CalendarDays,
  CalendarTime,
  TimeOfDay,
} from "./";

export function CalendarDatePickerDropdown(props) {
  //Destructure the passed props
  const {
    date, //The date object
    calendar, //The calendar object for parsing
    updateOnChange, //Should the value update automatically on each change? (can cause multiple re-renders)
    updateDate, //Function to update the date
    confirmDate,
    tooltipID,
    align,
  } = props;

  const handleConfirm = () => {
    confirmDate();
  };

  // console.log('Dropdown Date: ', date, calendar);
  return (
    <div
      className="chronos-calendar-date-picker-dropdown"
      style={{ [align]: "1px" }}
    >
      {date && date !== null && (
        <React.Fragment>
          <YearHeaderInput
            date={date}
            year={date.year}
            calendar={calendar}
            update={updateDate}
            tooltipID={tooltipID}
          />
          <MonthHeaderInput
            date={date}
            calendar={calendar}
            update={updateDate}
            tooltipID={tooltipID}
          />
          <CalendarDays date={date} calendar={calendar} update={updateDate} />
          <CalendarTime date={date} calendar={calendar} update={updateDate} />
          <CalendarDatePickerConfirm update={handleConfirm} />
        </React.Fragment>
      )}
    </div>
  );
}

function CalendarDatePickerConfirm({ update }) {
  const handleClick = (ev) => {
    ev.preventDefault();
    update();
  };
  return (
    <div className="chronos-calendar-date-picker-confirm">
      <Button block color="primary" onClick={handleClick}>
        <Icon icon="fas fa-save" />
        &nbsp;Set Date
      </Button>
    </div>
  );
}
